module.exports = __webpack_public_path__ + "static/media/story-bg.c233bf02.png";